import dayjs from 'dayjs';
/**
 * 有小数，则保留两位
 * @param money 价格
 */
export function toDoubleDigits(money: string | number) {
  if (typeof money === 'string') {
    money = parseFloat(money);
    if (isNaN(money)) {
      money = 0;
    }
  }
  return money.toFixed(2).replace(/\.?0+$/, '');
}
export function formatDate(date: string | Date) {
  return dayjs(date).format('YYYY-MM-DD');
}

export function formatDateTime(date: string | Date) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}



// WEBPACK FOOTER //
// ./src/utils/format.ts